<template>
  <div>
    <v-text-field
      v-model="searchDentalConsultations"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      class="mx-5 mb-3"
    ></v-text-field>
    <v-data-table
      :headers="headersDentalConsulting"
      :items="listDentalConsultations"
      :search="searchDentalConsultations"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
    >
      <template v-slot:[`item.diagnostic`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span color="red" dark v-bind="attrs" v-on="on">
              {{ item.diagnostic }}
            </span>
          </template>
          <span>{{ item.diagnostic1 }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.count`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="downloadDentalConsultation(item)"
              :disabled="item.idDiagnostic == null"
            >
              <v-icon color="red" dark v-bind="attrs" v-on="on">
                mdi-file-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>Descargar consulta PDF</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    downloadDentalConsultation: Function,
    listDentalConsultations: Array,
  },
  data() {
    return {
      searchDentalConsultations: "",
      headersDentalConsulting: [
      { text: "#", value: "count" },
      { text: "ID consulta", value: "idMedicalPractice" },
      { text: "Fecha de solicitud", value: "registrationDate" },
      { text: "Fecha de consulta", value: "consultationDate" },
      { text: "Doctor", value: "doctorName" },
      { text: "Diagnóstico", value: "diagnostic" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    };
  },
};
</script>

<style></style>
